<template>
  <div class="flex flex-col w-full items-center">
    <img :src="imageSrc" class="w-66 h-66" />
    <div class="text-text-glass-default text-m-medium">{{ t('setting.pairing.emptyText') }}</div>
  </div>
</template>

<script setup lang="ts">
  import emptyTip from '@/assets/images/devices/keys/empty.webp'
  import { useAnimatedImage } from '@/composables/useAnimatedImage'
  import { useLocaleStore } from '@/stores'
  const { t } = useLocaleStore()
  const { imageSrc } = useAnimatedImage(emptyTip)
</script>
